import { useEffect, useState } from "react";
import { api } from "../api";
import AgeGate from "../components/store/AgeGate";
import Header from "../components/store/Header";
import Hero from "../components/store/Hero";
import ProductCard from "../components/store/ProductCard";
import { BrandShowcase, PaymentDelivery, TrustGuarantees } from "../components/store/Sections";
import { AboutUs, BulkDiscounts, CookieBanner, Testimonials } from "../components/store/Extra";
import Faq from "../components/store/Faq";
import Referrals from "../components/store/Referrals";
import CartDrawer from "../components/store/CartDrawer";
import SiteFooter, { FloatingReferral, FloatingWhatsApp } from "../components/store/Footer";

export default function Store() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setProducts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#16181D] text-[#F2F4F6]">
      <AgeGate />
      <Header />
      <main>
        <Hero />
        <section id="catalogo" data-testid="catalog-section" className="px-4 py-16 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
              <div>
                <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-[#2EE6D6]">
                  Ofertas activas
                </p>
                <h2 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
                  Catálogo destacado
                </h2>
              </div>
              <p className="max-w-md rounded-xl border border-[#7C5CFF]/30 bg-[#7C5CFF]/10 px-4 py-2.5 text-xs leading-relaxed text-[#C9BEFF]">
                Pide por unidades sueltas o caja de 10 mezclando sabores{" "}
                <span className="font-bold">sin coste extra</span>.
              </p>
            </div>

            {loading ? (
              <div className="my-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="h-[480px] animate-pulse rounded-2xl border border-[#2D323E] bg-[#1E2128]"
                  />
                ))}
              </div>
            ) : products.length === 0 ? (
              <p className="my-16 text-center text-[#8A8F98]">
                No hay productos disponibles ahora mismo. Vuelve pronto o pregúntanos por WhatsApp.
              </p>
            ) : (
              <div
                data-testid="catalog-grid"
                className="my-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8"
              >
                {products.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            )}
          </div>
        </section>
        <BulkDiscounts />
        <Referrals />
        <BrandShowcase />
        <AboutUs />
        <TrustGuarantees />
        <PaymentDelivery />
        <Testimonials />
        <Faq />
      </main>
      <SiteFooter />
      <FloatingWhatsApp />
      <FloatingReferral />
      <CookieBanner />
      <CartDrawer />
    </div>
  );
}
